import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    padding: '16px',
    paddingTop: 0,
  },
  label: {
    fontSize: 14,
    marginY: '4px',
    whiteSpace: 'nowrap',
    color: 'common.grey850',
  },
  bold: {
    fontWeight: '600',
  },
  labelContainer: {
    display: 'flex',
    whiteSpace: 'nowrap',
  },
  flexMax: {
    flex: 1,
  },
  wrapText: {
    whiteSpace: 'pre-wrap',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
